document.addEventListener("DOMContentLoaded", function() {
    const popupOverlaySubscription = document.getElementById("popupOverlay--subscription");
    // append the popup overlay to the body
    document.body.appendChild(popupOverlaySubscription);
    
    const seeMoreButton = document.querySelector('.see-more-button');
    const toggleText = seeMoreButton.querySelector('.toggle-text');
    const chevron = seeMoreButton.querySelector('.circle-chevron');
    const expandableContent = document.querySelector('.expandable-content');

    const seeMoreText = toggleText.textContent;
    const seeLessText = toggleText.dataset.seelesstext;

    seeMoreButton.addEventListener('click', function() {
        if (toggleText.textContent === seeMoreText) {
            toggleText.textContent = seeLessText;
            expandableContent.classList.add('show-content');
        } else {
            toggleText.textContent = seeMoreText;
            expandableContent.classList.remove('show-content');
        }
    });
});

// JavaScript function to open the pop-up
function openPopupDrawer(text, cart) {

    var popup = document.getElementById("popupOverlay");
    if (text === "subscription") popup = document.getElementById("popupOverlay--subscription");
    popup.style.display = "flex";
    popup.querySelector(".popup").scrollTo(0, 0);
    document.querySelector("body").style.overflow = "hidden";
    if (text == "contribe") {
        popup.querySelector(".contribe-content").style.display = "block";
    } else if (text == "subscription") {
        popup.querySelector(".subscription-content").style.display = "block";
    }
}

// JavaScript function to close the pop-up
function closePopup(text) {
    var popup = document.getElementById("popupOverlay");
    if (text === "subscription") popup = document.getElementById("popupOverlay--subscription");
    popup.style.display = "none";
    document.querySelector("body").style.overflow = "auto";
    popup.querySelector(".contribe-content").style.display = "none";
    popup.querySelector(".subscription-content").style.display = "none";
}

if (document.querySelector(".info-text")) {
    document.querySelector(".info-text").addEventListener("click", ()=>openPopupDrawer('subscription'));
}

if (document.getElementById("popupOverlay")) {
    document.getElementById("popupOverlay").addEventListener("click", closePopup);
}

function changeSubscription(input_field) {
    if (input_field.checked) {

    console.log("checked");
    document.querySelector(".subscription-offer").classList.add("active");

    const id = window.filterVariantID || 47758049968425;
    const sellingPlan = window.filterSellingPlanInput || 692770439465;
    const url = `/cart/change.js?id=${id}&selling_plan=${sellingPlan}`;
    fetch(url, { method: "POST" })
        .then((response) => {
        return response.json();
        })
        .then((data) => {
        const cartRefreshEvent = new CustomEvent("cart:refresh");
        document.dispatchEvent(cartRefreshEvent);
        })
        .catch((error) => {
        alert("Udsolgt")
        console.error("Error:", error);
        });
    } else {
        document.querySelector(".subscription-offer").classList.remove("active");
        const id = window.filterVariantID || 47758049968425;
        const sellingPlan = "null";
        const url = `/cart/change.js?id=${id}&selling_plan`;
        fetch(url, { method: "POST" })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            const cartRefreshEvent = new CustomEvent("cart:refresh");
            document.dispatchEvent(cartRefreshEvent);
        })
        .catch((error) => {
            alert("Udsolgt")
            console.error("Error:", error);
        });
        
    }
}

function upsellFilter() {
    
    const addProductId = 49465098043689;
    const productProperties = {
        "Et års forbrug": "4 x MILO Filter"
    };
    const addProductUrl = `/cart/add.js?id=${addProductId}`;
    
    fetch(addProductUrl, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: addProductId,
                quantity: 1,
                properties: productProperties
            })
        })
        .then((response) => response.json())
        .then(() => {
            // Step 4: Refresh the cart
            const cartRefreshEvent = new CustomEvent("cart:refresh");
            document.dispatchEvent(cartRefreshEvent);
        })
        .catch((error) => {
            alert("An error occurred while processing your request.");
            console.error("Error:", error);
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'upsellFilter',
            upsell: 'Et års forbrug'
        });
}


// function upgradeToSubscription(event) {
//     console.log("clicked");

//     // add class loading to button
//     event.target.classList.add("custom-add-to-cart--loading");
//     // set state to hovered
//     event.target.classList.add("custom-add-to-cart--hovered");

//     const removeProductId = window.showerHeadNonSubsTypeID || 47694626226473;
//     const addProductId = window.showerHeadTypeID || 49053825761577;
//     const subscriptionProductId = window.showerHeadFilterVariantID || 47758204666153;
//     const sellingPlanId = window.showerHeadSellingPlanInput || 692725711145;

//     const productProperties = {
//         "Inklusiv MILO Filter": window.showerHeadProperties
//     };

//     // Step 1: Remove the product with id = 47694626226473
//     const removeUrl = `/cart/change.js?line=1&quantity=0&id=${removeProductId}`;
    
//     fetch(removeUrl, { method: "POST" })
//         .then((response) => response.json())
//         .then(() => {
//             // Step 3: Add the product with selling plan
//             const subscriptionUrl = `/cart/add.js?id=${subscriptionProductId}&selling_plan=${sellingPlanId}`;
//             return fetch(subscriptionUrl, { method: "POST" });
//         })
//         .then((response) => response.json())
//         .then(() => {
//             // Step 2: Add the product with id = 49053825761577
//             const addProductUrl = `/cart/add.js?id=${addProductId}`;
//             return fetch(addProductUrl, {
//                 method: "POST",
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({
//                     id: addProductId,
//                     quantity: 1,
//                     properties: productProperties
//                 })
//             });
//         })
//         .then((response) => response.json())
//         .then(() => {
//             // Step 4: Refresh the cart
//             const cartRefreshEvent = new CustomEvent("cart:refresh");
//             document.dispatchEvent(cartRefreshEvent);
//         })
//         .catch((error) => {
//             alert("An error occurred while processing your request.");
//             console.error("Error:", error);
//         });

            // dataLayer.push({
            //     event: 'upsellFilter',
            //     upsell: 'Subscription'
            // });
// }
function handleRemoveSubscription(event) {
    // 1) show loading spinner
    const lineItem = event.target.closest('.line-item');
    lineItem
      ?.querySelector('.line-item__media-wrapper .pill-loader')
      ?.setAttribute('aria-busy', 'true');
  
    const filterVariantID     = Number(window.showerHeadFilterVariantID);
    const subscriptionIDs     = Object.values(window.showerheadVariantMap.subscription)
                                      .map(id => Number(id));
  
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        // find the filter-subscription line
        const filterItem = cart.items.find(item => item.variant_id === filterVariantID);
  
        // find all subscription-mode showerhead lines
        const showerItems = cart.items.filter(item =>
          subscriptionIDs.includes(item.variant_id)
        );
  
        // collect all the line-item keys to remove
        const keysToRemove = [];
        if (filterItem)   keysToRemove.push(filterItem.key);
        showerItems.forEach(i => keysToRemove.push(i.key));
  
        // dispatch all removals
        return Promise.all(
          keysToRemove.map(key =>
            fetch(`/cart/change?id=${key}&quantity=0`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' }
            })
          )
        );
      })
      .then(() => {
        // refresh the cart UI
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(err => {
        console.error('Error removing subscription items:', err);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
  }

function removeMiloShowerheadItems(event) {
  // 1) show loading spinner for the specific line item
  const lineItem = event.target.closest('.line-item');
  lineItem
    ?.querySelector('.line-item__media-wrapper .pill-loader')
    ?.setAttribute('aria-busy', 'true');

  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      // Get the clicked item's variant ID from the line item
      const lineItem = event.target.closest('.line-item');
      const clickedVariantId = lineItem?.querySelector('[data-line-item-id]')?.dataset.lineItemId;
      const clickedItem = clickedVariantId ? cart.items.find(item => item.variant_id === Number(clickedVariantId)) : null;
      
      // Find all items that contain "MILO Brusehoved" in their title
      const miloShowerheadItems = cart.items.filter(item =>
        item.title && item.title.includes('MILO Brusehoved')
      );

      // Collect all the line-item keys to remove
      const keysToRemove = [];
      
      // Add the clicked item if found (regardless of whether it's a MILO Brusehoved item)
      if (clickedItem) {
        keysToRemove.push(clickedItem.key);
        console.log('Adding clicked item to removal list:', clickedItem.title);
      }
      
      // Add all MILO Brusehoved items (avoiding duplicates)
      miloShowerheadItems.forEach(item => {
        if (!keysToRemove.includes(item.key)) {
          keysToRemove.push(item.key);
          console.log('Adding MILO Brusehoved item to removal list:', item.title);
        }
      });

      if (keysToRemove.length === 0) {
        console.log('No MILO Brusehoved items found in cart');
        return Promise.resolve();
      }

      console.log(`Found ${keysToRemove.length} MILO Brusehoved items to remove:`, miloShowerheadItems.map(item => item.title));

      // Dispatch all removals
      return Promise.all(
        keysToRemove.map(key =>
          fetch(`/cart/change?id=${key}&quantity=0`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          })
        )
      );
    })
    .then(() => {
      // Refresh the cart UI
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      console.log('Successfully removed all MILO Brusehoved items from cart');
    })
    .catch(err => {
      console.error('Error removing MILO Brusehoved items:', err);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
}

// Shipping insurance: add item before checkout if checkbox selected
(function() {
  var isProcessingInsurance = false;

  function getShippingInsuranceCheckbox() {
      return document.getElementById('shipping-insurance');
  }

  function getInsuranceId() {
      var el = getShippingInsuranceCheckbox();
      if (!el) return null;
      var raw = el.getAttribute('data-product-id');
      if (!raw) return null;
      // Normalize to numeric string (theme may pass numeric as string)
      return String(raw).replace(/[^0-9]/g, '');
  }

  async function getCartJson() {
      try {
          var resp = await fetch(Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } });
          return await resp.json();
      } catch (_) {
          return null;
      }
  }

  async function syncInsuranceCheckboxWithCart(cart) {
      try {
          var checkbox = getShippingInsuranceCheckbox();
          if (!checkbox) return;
          var insuranceId = getInsuranceId();
          if (!insuranceId) return;

          var currentCart = cart;
          if (!currentCart) {
              currentCart = await getCartJson();
          }
          if (!currentCart) return;

          var present = Array.isArray(currentCart.items) && currentCart.items.some(function(item) {
              return String(item.id) === String(insuranceId) || String(item.product_id) === String(insuranceId);
          });
          checkbox.checked = !!present;
      } catch (_) {}
  }

  async function addInsuranceIfNeeded() {
      var checkbox = getShippingInsuranceCheckbox();
      if (!checkbox || !checkbox.checked) return { handled: false };

      var insuranceId = getInsuranceId();
      if (!insuranceId) return { handled: false };

      if (isProcessingInsurance) return { handled: true };
      isProcessingInsurance = true;
      try {
          // Optimistically update UI immediately
          updateImageFilter();

          var cart = await getCartJson();
          var alreadyInCart = false;
          try {
              alreadyInCart = Array.isArray(cart && cart.items) && cart.items.some(function(item) {
                  return String(item.id) === String(insuranceId) || String(item.product_id) === String(insuranceId);
              });
          } catch (_) {}

          if (alreadyInCart) {
              // Trigger refresh to update cart drawer
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
              return { handled: true, added: false };
          }

          try {
              var addResp = await fetch(Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest'
                  },
                  body: JSON.stringify({
                      items: [ { id: Number(insuranceId), quantity: 1 } ]
                  })
              });

              if (addResp && addResp.ok) {
                  // Get the updated cart from the add response or fetch it
                  var updatedCart = null;
                  try {
                      updatedCart = await addResp.json();
                  } catch (_) {}

                  // If add response doesn't include full cart, fetch it
                  if (!updatedCart || !updatedCart.items) {
                      try {
                          updatedCart = await getCartJson();
                      } catch (_) {}
                  }

                  if (updatedCart) {
                      // Dispatch events to update cart drawer
                      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: updatedCart } }));
                      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: updatedCart } }));
                      try { checkbox.checked = true; } catch (_) {}
                      return { handled: true, added: true };
                  }
              }
          } catch (_) {}

          return { handled: true, added: false };
      } finally {
          isProcessingInsurance = false;
      }
  }

  async function removeInsuranceIfPresent() {
      var insuranceId = getInsuranceId();
      if (!insuranceId) return { handled: false };

      if (isProcessingInsurance) return { handled: true };
      isProcessingInsurance = true;
      try {
          // Optimistically update UI immediately
          updateImageFilter();

          var cart = await getCartJson();
          var present = false;
          try {
              present = Array.isArray(cart && cart.items) && cart.items.some(function(item) {
                  return String(item.id) === String(insuranceId) || String(item.product_id) === String(insuranceId);
              });
          } catch (_) {}

          if (!present) {
              // Trigger refresh to update cart drawer
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
              return { handled: true, removed: false };
          }

          try {
              var resp = await fetch(Shopify.routes.root + 'cart/update.js', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest'
                  },
                  body: JSON.stringify({ updates: (function(){ var u = {}; u[String(insuranceId)] = 0; return u; })() })
              });
              var updatedCart = null;
              try {
                  updatedCart = await resp.json();
              } catch (_) {}
              if (resp && resp.status === 200 && updatedCart) {
                  // Dispatch events to update cart drawer
                  document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:remove', cart: updatedCart } }));
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: updatedCart } }));
                  try { var cb = getShippingInsuranceCheckbox(); if (cb) cb.checked = false; } catch (_) {}
                  return { handled: true, removed: true };
              }
          } catch (_) {}

          return { handled: true, removed: false };
      } finally {
          isProcessingInsurance = false;
      }
  }

  // Update image filter based on checkbox state
  function updateImageFilter() {
      var checkbox = getShippingInsuranceCheckbox();
      if (!checkbox) return;

      var container = checkbox.closest('.shipping-insurance');
      if (!container) return;

      var image = container.querySelector('.shipping-insurance__image');
      if (!image) return;

      if (checkbox.checked) {
          image.style.filter = 'grayscale(0%)';
          image.style.opacity = '1';
      } else {
          image.style.filter = 'grayscale(100%)';
          image.style.opacity = '0.6';
      }
  }

  // Toggle add/remove on checkbox change (delegated for drawer re-renders)
  document.addEventListener('change', function(e) {
      var target = e && e.target ? e.target : null;
      if (!target || target.id !== 'shipping-insurance') return;

      // Update image filter
      updateImageFilter();

      // Prevent rapid double toggles
      try { target.disabled = true; } catch (_) {}
      var action = target.checked ? addInsuranceIfNeeded() : removeInsuranceIfPresent();
      Promise.resolve(action).finally(function() {
          var cb = getShippingInsuranceCheckbox();
          if (cb) { try { cb.disabled = false; } catch (_) {} }
      });
  }, true);

  // Keep checkbox state in sync with cart contents
  document.addEventListener('DOMContentLoaded', function() {
      syncInsuranceCheckboxWithCart();
      updateImageFilter();
  });

  document.addEventListener('cart:change', function(e) {
      var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
      syncInsuranceCheckboxWithCart(cart);
      updateImageFilter();
  });

  document.addEventListener('line-item:change', function(e) {
      var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
      syncInsuranceCheckboxWithCart(cart);
      updateImageFilter();
  });

  document.addEventListener('variant:add', function(e) {
      var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
      syncInsuranceCheckboxWithCart(cart);
      updateImageFilter();
  });

  document.addEventListener('cart:refresh', function() {
      // cart drawer re-renders; fetch fresh cart and sync
      syncInsuranceCheckboxWithCart();
      updateImageFilter();
  });
})();